import React, { useState } from 'react';
import '../App.css';
import axios from 'axios';
import signupHeroImage from '../assets/mobility.jpeg';
// Toaster icons ke liye
import { CheckCircle, AlertCircle, X } from "lucide-react"; 

const Signup = () => {
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  
  // Toast and Loading State
  const [toast, setToast] = useState({ type: "", message: "" });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      setToast({ type: "error", message: "Passwords do not match" });
      setTimeout(() => setToast({ type: "", message: "" }), 4000);
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post("https://www.api.teqnoor.info/api/v1/users/register", {
        fullname: name,
        phonenumber: phone,
        email,
        password
      });

      console.log("Response:", response.data);
      setToast({ type: "success", message: "Registration successful!" });

      // Clear form
      setName('');
      setPhone('');
      setEmail('');
      setPassword('');
      setConfirmPassword('');

    } catch (err) {
      console.error(err);
      const errorMsg = err.response?.data?.message || "Registration failed";
      setToast({ type: "error", message: errorMsg });
    } finally {
      setLoading(false);
      // 4 second baad toast hide ho jaye
      setTimeout(() => setToast({ type: "", message: "" }), 4000);
    }
  };

  return (
    <div className="signup-page container-fluid position-relative p-0 d-sm-block d-none">
      <img src={signupHeroImage} alt="Calisthenics" className="hero-image" />

      <div className="trail-form d-flex">
        <div className="left">
          <h1>FREE 7-DAY TRIAL SIGNUP</h1>
          <p>Sign up for a free 7-day trial with me and experience my services for free.</p>
        </div>

        <div className="forms">
          <form onSubmit={handleSubmit}>
            {/* Purane error/success labels hata diye hain taake toast use ho */}

            <div className="input-row">
              <div className="input-box">
                <label>Name</label>
                <input type="text" placeholder="William Henry" value={name} onChange={(e) => setName(e.target.value)} required />
              </div>

              <div className="input-box">
                <label>Phone number</label>
                <input type="tel" placeholder="+1 234 567 8900" value={phone} onChange={(e) => setPhone(e.target.value)} required />
              </div>
            </div>

            <div className="input-group">
              <label>Email</label>
              <input type="email" placeholder="william@gmail.com" value={email} onChange={(e) => setEmail(e.target.value)} required />
            </div>

            <div className="input-group">
              <label>Password</label>
              <input type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} required />
            </div>

            <div className="input-group">
              <label>Confirm Password</label>
              <input type="password" placeholder="Confirm Password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} required />
            </div>

            <button type="submit" disabled={loading}>
              {loading ? "Submitting..." : "Submit"}
            </button>
          </form>
        </div>
      </div>

      {/* --- PREMIUM TOAST UI --- */}
      {toast.message && (
        <div className="premium-toast-container">
          <div className={`toast-icon-wrapper ${toast.type}`}>
            {toast.type === "success" ? (
              <CheckCircle size={24} color="#10b981" />
            ) : (
              <AlertCircle size={24} color="#ef4444" />
            )}
          </div>

          <div className="toast-content">
            <span className="toast-title">
              {toast.type === "success" ? "Success" : "Error"}
            </span>
            <span className="toast-message">{toast.message}</span>
          </div>

          <X 
            className="toast-close-btn" 
            size={18} 
            onClick={() => setToast({ type: "", message: "" })} 
          />
        </div>
      )}
    </div>
  );
};

export default Signup;